<template>
  <div class="">
    <b-button v-b-toggle.ReservationsSchedules class="btn btn-lg btn-collapse">
      {{ $t("pages.ReservationsSchedules") }}
      <i class="fa fa-angle-down" aria-hidden="true"></i>
    </b-button>
    <b-collapse id="ReservationsSchedules">
      <div class="my-card">
        <div class="row">
          <!-- <div class="form-label-group col-md-6 col-lg-4">
            <input
              type="checkbox"
              id="reservationsSchedulesView"
              v-model="
                usersPrivilegeReservationsSchedules.reservationsSchedulesView
              "
              class="checkbox"
            />
            <label class="mt-1 ml-2" for="reservationsSchedulesView">{{
              $t("view")
            }}</label>
          </div> -->
          <!-- <div class="form-label-group col-md-6 col-lg-4">
            <input
              type="checkbox"
              id="reservationsSchedulesAdd"
              v-model="
                usersPrivilegeReservationsSchedules.reservationsSchedulesAdd
              "
              class="checkbox"
            />
            <label class="mt-1 ml-2" for="reservationsSchedulesAdd">{{
              $t("add")
            }}</label>
          </div> -->
          <div class="form-label-group col-md-6 col-lg-4">
            <input
              type="checkbox"
              id="reservationsSchedulesApprove"
              v-model="
                usersPrivilegeReservationsSchedules.reservationsSchedulesApprove
              "
              class="checkbox"
            />
            <label class="mt-1 ml-2" for="reservationsSchedulesApprove">{{
              $t("approved")
            }}</label>
          </div>
        </div>
      </div>
    </b-collapse>
  </div>
</template>

<script>
export default {
  name: "UsersPrivilegeReservationsSchedules",
  data() {
    return {
      language: localStorage.getItem("userLanguage") || "ar",
    };
  },
  props: ["usersPrivilegeReservationsSchedules"],
  methods: {},
};
</script>

<style scoped lang="scss"></style>
